import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text="Projects" mdxType="Title" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/IoT-Roadmap"
        }}>{`IoT Development RoadMap 🧑‍💻 `}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/Smart-Parking-App"
        }}>{`Smart Parking App `}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/Chicken-invaders-game"
        }}>{`Chicken Invaders in the Browser`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/Bash-Shell-DBMS"
        }}>{`Bash Shell DBMS`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/would-you-rather-reactnd"
        }}>{`React Nanodegree Would you Rather App`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/my-reads-app"
        }}>{`React Nanodegree My Reads App`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/coffeshop-api"
        }}>{`FullStack Nanodegree Coffe Shop App`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/trivia_api"
        }}>{`FullStack Nanodegree Trivia App`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mahmoodfathy/fyyur"
        }}>{`FullStack Nanodegree Fyyur App`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      